var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7764 4.12891L14.1236 11.7816C13.2703 12.6328 12.1143 13.1108 10.9091 13.1108C9.70387 13.1108 8.54784 12.6328 7.69454 11.7816L0.0418182 4.12891C0.0290909 4.27254 0 4.40254 0 4.54527V15.4544C0.00144351 16.6594 0.480802 17.8148 1.33293 18.6669C2.18505 19.519 3.34037 19.9984 4.54545 19.9998H17.2727C18.4778 19.9984 19.6331 19.519 20.4853 18.6669C21.3374 17.8148 21.8167 16.6594 21.8182 15.4544V4.54527C21.8182 4.40254 21.7891 4.27254 21.7764 4.12891Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8376 10.4964L21.1412 2.19182C20.739 1.52484 20.1716 0.972761 19.4939 0.588846C18.8162 0.20493 18.051 0.00212788 17.2721 0H4.54487C3.76598 0.00212788 3.00078 0.20493 2.32308 0.588846C1.64537 0.972761 1.07803 1.52484 0.675781 2.19182L8.97942 10.4964C9.49175 11.0066 10.1854 11.2932 10.9085 11.2932C11.6316 11.2932 12.3253 11.0066 12.8376 10.4964Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcons);
export default __webpack_public_path__ + "static/media/email_icons.97af0f55d5c3d874e626d85a4f6f4e89.svg";
export { ForwardRef as ReactComponent };